var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfomodelBindTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.502 10.571H3.714A.571.571 0 013.143 10V5.429h8.571V10a.571.571 0 01-.571.571h-.982a.571.571 0 100 1.143h.982c.947 0 1.714-.767 1.714-1.714V3.714c0-.946-.767-1.714-1.714-1.714H3.714C2.768 2 2 2.768 2 3.714V10c0 .947.768 1.714 1.714 1.714h1.788a.571.571 0 100-1.143zm-2.36-6.857c0-.315.257-.571.572-.571h7.429c.315 0 .571.256.571.571v.572H3.143v-.572z",
    fill: "#3B65EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.983 8.286a.571.571 0 110 1.143H8.857a.571.571 0 00-.571.571v4.571h8.571V10a.571.571 0 00-.571-.571h-1.623a.571.571 0 010-1.143h1.623C17.232 8.286 18 9.053 18 10v6.286c0 .946-.768 1.714-1.714 1.714H8.857a1.714 1.714 0 01-1.714-1.714V10c0-.947.767-1.714 1.714-1.714zm6.874 7.428H8.286v.572c0 .315.256.571.571.571h7.429a.571.571 0 00.571-.571v-.572z",
    fill: "#191C26"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfomodelBindTag);
export default __webpack_public_path__ + "static/assets/infomodel-bind-tag.5fe9e3f4.svg";
export { ForwardRef as ReactComponent };